/** Half-open intervals [start,end): midnight endings do not occupy the next day. */
export function meetingIntersectsDay(meeting:Record<string,unknown>,day:string):boolean{
 const start=Date.parse(String(meeting.start_at)),end=Date.parse(String(meeting.end_at)),midnight=Date.parse(`${day}T00:00:00+05:00`);
 return [start,end,midnight].every(Number.isFinite)&&end>start&&start<midnight+86_400_000&&end>midnight;
}
